import { Component, OnInit } from '@angular/core';
import { merge, Observable, of } from 'rxjs';
import { WalletService } from 'src/app/services/wallet.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  updateClass(className: string) {
    (document as any).body.className = className;
  }

  walletAddress$: Observable<string>;

  constructor(private walletService: WalletService) {
    this.walletAddress$ = merge(
      of('...'),
      this.walletService.userAddressCropped()
    );
  }

  ngOnInit(): void {
    // this.walletService.desync().subscribe();
  }

  get hasPermission() {
    return this.walletService.hasPermission();
  }

  syncWallet() {
    this.walletService.requestPermission().subscribe();
  }

  unsyncWallet() {
    this.walletService.desync().subscribe();
  }
}
